import React from 'react';
import { Route } from "react-router-dom";
import DashboardView from './dashboard.view';


const DashBoardRouter = ({ match }) => (
  <div>
    <Route
      path={match.path}
      component={DashboardView}
    />
  </div>
);

export default DashBoardRouter;
